/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_CountsInputs */

const en_nav_warehouse_counts = /** @type {(inputs: Nav_Warehouse_CountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse counts`)
};

/**
* | output |
* | --- |
* | "Warehouse counts" |
*
* @param {Nav_Warehouse_CountsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_counts = /** @type {((inputs?: Nav_Warehouse_CountsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_CountsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_warehouse_counts(inputs)
});